'use client'
import Image from 'next/image'
import { Stories as StoriesType, SmartLink } from '@/payload-types'
import SmartLinksComponent from '../smart-links/smartLinks'
import { IBackgroundColor } from './ProfilesSection'
import { CANARY_MISSION } from '@/enum/enum'
import { useEffect, useRef } from 'react'

interface IProps {
  profileStories: StoriesType
  backgroundColor?: IBackgroundColor
  onImageClick?: () => void
}

export const ProfileStories = ({ profileStories, onImageClick, backgroundColor }: IProps) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.style.setProperty(
        '--story-background',
        backgroundColor?.darkBackgroundColor || '',
      )
      wrapperRef.current.style.setProperty(
        '--story-background-dark',
        backgroundColor?.backgroundColor || '',
      )
    }
  }, [backgroundColor?.backgroundColor, backgroundColor?.darkBackgroundColor, wrapperRef])

  return (
    <div
      ref={wrapperRef}
      className="flex flex-col justify-center items-center lg:pt-[80px] ease-in duration-500
      bg-gradient-to-t from-black via-[--story-background] to-[--story-background-dark]
      [transition-property:_--story-background,_--story-background-dark]"
    >
      <p className="text-white text-center font-poppins md:text-[25px] text-[18px] font-bold leading-snug max-w-[750px] m-11">
        {CANARY_MISSION.NAME} documents individuals and groups that promote hatred of the USA,
        Israel and Jews, using publicly available content.
      </p>
      <div className="flex items-center justify-center sm:w-[70vw] w-[90vw] mb-[27px] min-h-[260px] sm:min-h-[150px] md:min-h-[375px] min-[1310px]:min-h-[200px]">
        <div className="text-white flex flex-wrap md:gap-x-[104px] gap-x-[30px] gap-y-[15px] justify-center">
          {profileStories?.map((story, index) => {
            const smartLink: SmartLink = {
              screenshot: story.images || [],
              blockName: story.title,
              blockType: 'smartlink',
              textToDisplay: story.title,
            }

            const imageTrigger = story.images?.[0] ? (
              <Image
                src={`${process.env.NEXT_PUBLIC_PAYLOAD_URL ?? ''}${
                  typeof story.images[0] === 'object'
                    ? story.images[0]?.sizes?.webp?.url || ''
                    : (story.images[0] as string) || ''
                }`}
                alt={story.title || ''}
                className=" md:h-[100px] h-[65px] rounded-full border border-black object-cover shadow-md cursor-pointer"
                width={100}
                height={100}
              />
            ) : null

            return (
              <div
                key={index + story.title}
                className="flex flex-col items-center md:max-w-[100px] max-w-[65px] animate-in fade-in slide-in-from-right-2"
                onMouseEnter={onImageClick}
                onClick={onImageClick}
                style={{
                  animationDelay: `${index * 0.1}s`,
                  animationFillMode: 'both',
                  animationDuration: '0.8s',
                }}
              >
                <div className="w-full">
                  <SmartLinksComponent
                    text={undefined}
                    smartLink={smartLink}
                    imageTrigger={imageTrigger}
                  />
                </div>
                <span className="text-center mt-2 font-semibold md:w-[120px] w-[85px] md:text-base text-xs">
                  {story.title}
                </span>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default ProfileStories
